<template>
  <div class="support-area">
    <section class="support-session">
      <header class="current-chat">
        <h5>Salvages</h5>
      </header>
      <div class="chat-session">
        <v-container grid-list-xl>
          <v-layout wrap>
            <v-flex xs4 v-for="car in carResponse" :key="car[0]" mb-2>
              <v-card>
                <v-img :src="car.media.photo_links[0]" aspect-ratio="2"></v-img>                
                <div style="font-size: 14px;text-align:center;padding-top:10px">
                  <b>{{ car.build.make }} {{ car.build.model }}</b>
                </div>
                <div style="font-size: 12px;padding-left:30px;padding-right:20px">
                  <v-row>
                    <v-col>
                      <div>Year: {{ car.build.year }}</div>
                      <div>Mileage: {{ car.miles }} km</div>
                    </v-col>
                    <v-col>
                      <div>Type: {{ car.build.vehicle_type }}</div>                  
                      <div>ZMW {{ car.price }}</div>
                    </v-col>
                  </v-row>
                </div>                
                <div style="text-align:center;padding:5px">
                  <v-btn
                    color="primary"
                    small
                    @click="$modal.show('salvage-bid-modal')"
                  >
                    Bid Now
                  </v-btn>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </section>
    <aside class="support-sidebar">
      <header class="current-chat">
        <h5>Locations</h5>
      </header>
      <ul class="room">
        <li          
          
        >
          All Branches
        </li>
        <li          
          
        >
          Lusaka
        </li>
        <li          
          
        >
          Addis Ababa
        </li>
        <li          
          
        >
          Woodlands
        </li>
        <li          
          
        >
          Kabwe
        </li>
        <li          
          
        >
          Ndola
        </li>
        <li          
          
        >
          Kitwe
        </li>
        <li          
          
        >
          Chingola
        </li>
        <li          
          
        >
          Solwezi
        </li>
        <li          
          
        >
          Chipata
        </li>
        <li          
          
        >
          Choma
        </li>
        <li          
          
        >
          Livingstone
        </li>
      </ul>
    </aside>
    <SalvageBidModal />
  </div>
</template>
<script>
  import axios from "axios";
  import SalvageBidModal from '@/components/modals/SalvageBidModal';

  //const carLogo = process.env.VUE_APP_CAR_LOGO;
  const URL = `https://marketcheck-prod.apigee.net/v1/search?&year=2016&car_type=used&make=lexus&api_key=JQibFNIfG82omiAwXr2hQdGnGs0Ad3Py&Content-Type=application/json`

  export default {
    name: 'Salvages',
    components: {
      SalvageBidModal
    },
    data() {
      return {
        carResponse: [],
        
      }
    },
    mounted() {
      axios
      .get(URL)
      .then(response => {
        this.carResponse = response.data.listings;
      })
      .catch(error => {
        console.log(error);
      });
    }
  }
</script>

<style>
  .support-area {
    width: 100vw;
    height: 680px;
    display: flex;
  }

  .support-sidebar {
    width: 20%;
    background-color: beige;
    height: 100%;
    border-left: 1px solid #ccc;
  }

  .support-sidebar li {
    list-style: none;
    border-bottom: 1px solid #ccc;
  }

  .support-sidebar li:hover {
    background-color: #f4f4ff;
  }

  .support-sidebar h3 {
    color: black;
    margin-bottom: 0;
    text-align: left;
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;
    
  }

  .room {
    font-size: 14px;
    color: black;
    cursor: pointer;
    text-align: left;
    padding: 10px 20px;
  
  }

  .room.active {
    background-color: #eaeafd;
    color: black;
  }

  .support-session {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
 
  }

  .current-chat {
    border-bottom: 1px solid #ccc;
    text-align: left;
    padding: 10px 20px;
    display: flex;
    background-color: beige;
  }

  .current-chat h3 {
    margin-bottom: 0;
  }

  .chat-session {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px 50px;
    font-size: 14px;
  }

  .message {
    background-color: #f6f6f6;
    clear: both;
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 5px;
    max-width: 80%;
  }

  .message.user {
    float: right;
    background-color: peachpuff;
  }

  .message.support {
    float: left;
    background-color: #ddd;
  }

  .message-form, .message-input {
    width: 100%;
    margin-bottom: 0;
  }

  .message-input {
    border-radius: 0;
    border: none;
    border-top: 1px solid #ccc;
    height: 50px;
    padding: 20px;
    font-size: 16px;
    background-color: #f6f6f6
  }
</style>